var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInputShevronDarkGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "5px",
    viewBox: "0 0 8 5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "38-Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bookkeping",
    transform: "translate(-910.000000, -272.000000)",
    fill: "#74818D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Input/icon/Filled",
    transform: "translate(767.000000, 227.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/input/shevron-dark-grey",
    transform: "translate(135.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.000000, 10.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.939999938,0 L4,3.05999894 L7.06000042,0 L8,0.946666368 L4,4.94666481 L0,0.946666368 L0.939999938,0 L0.939999938,0 Z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInputShevronDarkGrey);
export default __webpack_public_path__ + "static/media/icon-input-shevron-dark-grey.482a59823ad676d3ac29832f6fcb89e5.svg";
export { ForwardRef as ReactComponent };